var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import AlertCard from '@/components/alert-card/AlertCard';
let BookmarksDialog = class BookmarksDialog extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.internalBookmark = {
            name: '',
            link: '',
        };
        this.isSubmitting = false;
        this.isSubmitted = false;
    }
    // Getters
    get isFormValid() {
        return !!(this.internalBookmark.link.length && this.internalBookmark.name.length);
    }
    get isDisabled() {
        if (this.isSubmitted || this.isSubmitting) {
            return true;
        }
        return !this.isFormValid;
    }
    get headerLabel() {
        if (this.confirmingDelete) {
            return this.$tc('scoollinks.dialog.delete.title');
        }
        if (this.bookmark) {
            return this.$tc('scoollinks.dialog.edit.title');
        }
        return this.$tc('scoollinks.dialog.create.title');
    }
    get subHeaderLabel() {
        return this.bookmark ? this.$tc('scoollinks.dialog.edit.subtitle') : this.$tc('scoollinks.dialog.create.subtitle');
    }
    get alertLabel() {
        return this.bookmark ? this.$tc('scoollinks.dialog.edit.submitted') : this.$tc('scoollinks.dialog.create.submitted');
    }
    get submitLabel() {
        return this.bookmark ? this.$tc('scoollinks.dialog.edit.submitting') : this.$tc('scoollinks.dialog.create.submitting');
    }
    get isNewBookmark() {
        return !(this.bookmark && this.bookmark.id);
    }
    get bookmarkPayload() {
        return {
            name: this.internalBookmark.name || '',
            link: this.internalBookmark.link || '',
        };
    }
    closeDialog() {
        this.clear();
        this.$emit('close');
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        if (this.bookmark) {
            this.internalBookmark.name = this.bookmark.name || '';
            this.internalBookmark.link = this.bookmark.link || '';
        }
        if (this.bookmarkPath) {
            this.internalBookmark.link = this.bookmarkPath;
        }
        this.isLoading = false;
    }
    async submit() {
        this.isSubmitting = true;
        this.isNewBookmark
            ? await this.createBookmark()
            : await this.updateBookmark();
        this.clear();
    }
    clear() {
        this.isSubmitted = false;
        this.isSubmitting = false;
    }
    // Asyncs
    async updateBookmark() {
        if (!this.bookmark || !this.bookmark.id) {
            return;
        }
        try {
            await this.$store.state.Auth.updateBookmark(this.bookmark.id, this.bookmarkPayload);
            this.$emit('close');
        }
        catch (error) {
            //
        }
    }
    async createBookmark() {
        try {
            await this.$store.state.Auth.createBookmark(this.bookmarkPayload);
            this.$emit('close');
        }
        catch (error) {
            //
        }
    }
    async deleteBookmark() {
        try {
            await this.$store.state.Auth.deleteBookmark(this.bookmark.id || '');
            this.$emit('close');
        }
        catch (error) {
            //
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], BookmarksDialog.prototype, "bookmark", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], BookmarksDialog.prototype, "confirmingDelete", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], BookmarksDialog.prototype, "bookmarkPath", void 0);
BookmarksDialog = __decorate([
    Component({
        components: {
            AlertCard,
        },
    })
], BookmarksDialog);
export default BookmarksDialog;
